import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, ...props }, ref) => {
  // Campi numerici: al tocco/click selezioniamo il valore già presente, così
  // digitando «2» su un «1» preimpostato si ottiene 2 e non 12.
  const handleFocus = (e) => {
    if (type === "number") {
      const el = e.target;
      requestAnimationFrame(() => { try { el.select(); } catch { /* noop */ } });
    }
    onFocus?.(e);
  };
  return (
    <input
      type={type}
      onFocus={handleFocus}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
